import { get } from 'axios';

const { VUE_APP_API_URL } = process.env || {};

export const getBrands = (token) => get(`${VUE_APP_API_URL}/api/v1/admin/brands`, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});
